export enum DocumentTemplateModalType {
  AddOrModify,
  ModifyConfirmCancel,
  Delete,
  Restore,
  Copy,
}
